import axios from 'api/axios'
import { useEffect, useState } from 'react'

const useFetchEsValidador = () => {
  const [esValidador, setEsValidador] = useState(false)
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setLoading(true)
    axios
      .get(`/solicitudespendientes/validador`)
      .then((response) => {
        setEsValidador(Boolean(response.data?.es_validador))
      })
      .catch((err) => setError(err))
      .finally(() => setLoading(false))
  }, [])

  return { esValidador, error, loading }
}

export default useFetchEsValidador
